import { render, staticRenderFns } from "./reportFeeDetailParkingSpace.vue?vue&type=template&id=a65efafc&scoped=true"
import script from "./reportFeeDetailParkingSpace.vue?vue&type=script&lang=js"
export * from "./reportFeeDetailParkingSpace.vue?vue&type=script&lang=js"
import style0 from "./reportFeeDetailParkingSpace.vue?vue&type=style&index=0&id=a65efafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65efafc",
  null
  
)

export default component.exports